import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Label from '@/components/Label';
import { carModelOptions } from '@/lib/constants';

export function CarModelSelector({ value, initialValue, onChange }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (initialValue && !value) {
      onChange(initialValue);
    }
  }, [initialValue, onChange, value]);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleSelectVehicle = (option) => {
    onChange(option.value);
    setIsDropdownOpen(false);
  };

  const selectedVehicleOption = carModelOptions.find(opt => opt.value === value);

  return (
    <>
      <Label>Modèle du véhicule</Label>
      <div className={`dropdown ${isDropdownOpen ? 'is-active' : ''} mb-3`}>
        <div className="dropdown-trigger">
          <button
            type="button"
            className="button is-fullwidth is-white"
            onClick={toggleDropdown}
            style={{
              border: '1px solid #dbdbdb',
              padding: '0.6rem 0.75rem',
              fontSize: '1rem'
            }}
            aria-haspopup="true"
            aria-controls="car-model-dropdown"
          >
            <div
              className="is-flex is-align-items-center is-justify-content-center"
              style={{ width: '100%', gap: '0.5rem' }}
            >
              <span className="dropdown-trigger-label">
                {selectedVehicleOption
                  ? selectedVehicleOption.label
                  : 'Sélectionnez un modèle similaire à votre véhicule'}
              </span>

              {selectedVehicleOption && (
                <figure className="image is-24x24">
                  <img
                    src={selectedVehicleOption.icon}
                    alt={selectedVehicleOption.label}
                  />
                </figure>
              )}

              <span className="icon is-small">
                <FontAwesomeIcon icon={faAngleDown}/>
              </span>
            </div>
          </button>
        </div>

        <div className="dropdown-menu" id="car-model-dropdown" role="menu">
          <div className="dropdown-content">
            {carModelOptions.map(option => (
              <a
                key={option.value}
                className="dropdown-item is-flex is-align-items-center is-justify-content-space-between"
                onClick={() => handleSelectVehicle(option)}
                style={{ gap: '0.5rem' }}
              >
                <span>{option.label}</span>
                <figure className="image is-24x24">
                  <img src={option.icon} alt={option.label} />
                </figure>
              </a>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .image.is-24x24 {
          width: 24px;
          height: 24px;
          display: inline-block;
        }
        .image.is-24x24 img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
        .button.is-white.has-text-left {
          border: 1px solid #dbdbdb;
          box-shadow: none;
        }
      `}</style>
    </>
  );
}
